<template>
    <div class="add-or-edit">
        <bread-crumb :bread-list="breadList" />
        <div class="add-content">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">新增问题</span>
            </div>
            <el-form :model="dataForm"
                     ref="dataForm"
                     :rules="rules"
                     v-loading="loading"
                     label-width="100px"
                     class="banner-form">
                <el-form-item label="类型"
                              prop="type">
                    <el-select size="small"
                               v-model="dataForm.type"
                               :style="{width: '320px!important'}">
                        <el-option v-for="item in typeList"
                                   :key="item.incId"
                                   :label="item.dictDataValue"
                                   :value="item.dictDataCode"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="标题"
                              prop="title">
                    <el-input v-model.trim="dataForm.title"
                              class="from-input"
                              placeholder="请输入标题"
                              maxlength="200">
                    </el-input>
                </el-form-item>

                <el-form-item label="排列序号"
                              prop="number">
                    <el-input-number v-model.trim="dataForm.number"
                                     class="from-input"
                                     placeholder="请输入排列序号"
                                     size="small"
                                     :controls="false"
                                     step-strictly></el-input-number>
                </el-form-item>

                <el-form-item label="内容"
                              prop="answer">
                    <el-input type="textarea"
                              :rows="8"
                              :style="{width: '320px!important'}"
                              placeholder="请输入内容"
                              v-model="dataForm.answer"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary"
                               class="submit-btn"
                               @click="submitForm('dataForm')">提交</el-button>
                    <el-button @click="handleCandle"
                               class="cancle-btn">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { addOrEditProblem } from '@/api/consulting'
export default {
    data () {
        return {
            questionId: '',
            handleType: '',
            breadList: [{ label: '咨询专区' }, { label: '常见问题', path: '/counsel/commonProblem' }, { label: '' }],
            typeList: [],
            dataForm: {
                title: '',
                type: '',
                number: null,
                answer: ''
            },
            rules: {
                title: [
                    { required: true, message: '请输入标题', trigger: 'blur' }
                ],
                type: [
                    { required: true, message: '请选择类型', trigger: 'change' }
                ],
                number: [
                    { required: true, message: '请输入排列序号', trigger: 'blur' }
                ],
                answer: [
                    { required: true, message: '请输入内容', trigger: 'blur' }
                ]
            },
            loading: false
        }
    },
    computed: {
        ...mapGetters([
            'dictionary'
        ])
    },
    created () {
        this.typeList = this.dictionary.CJWT
        if (this.$route.path === '/counsel/commonProblem/add') {
            this.handleType = 'add'
            this.breadList[2].label = '新增问题'
        } else {
            this.handleType = 'edit'
            this.breadList[2].label = '编辑问题'
            let data = JSON.parse(sessionStorage.getItem('editProblem'))
            if (data) {
                this.questionId = data.questionId
                this.dataForm.title = data.title
                this.typeList.forEach(item => {
                    if (item.dictDataValue === data.type) {
                        this.dataForm.type = item.dictDataCode
                    }
                })
                this.dataForm.number = data.number
                this.dataForm.answer = data.answer
            }
        }
    },
    methods: {
        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let params = {
                        questionId: this.questionId,
                        title: this.dataForm.title,
                        type: this.dataForm.type,
                        number: this.dataForm.number,
                        answer: this.dataForm.answer
                    }
                    this.loading = true
                    addOrEditProblem(params).then(res => {
                        if (res.state === 200) {
                            this.loading = false
                            this.$message({
                                message: this.handleType === 'add' ? '新增成功' : '编辑成功',
                                customClass: 'hos-message--success',
                                iconClass: 'el-icon-success',
                                duration: '1000'
                            })
                            this.$router.push('/counsel/commonProblem')
                        }
                    })
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        handleCandle () {
            this.$router.push('/counsel/commonProblem')
        }
    }
}
</script>
<style lang="scss">
.add-or-edit {
    height: 100%;
    .add-content {
        min-height: calc(100% - 95px);
        box-shadow: 0 1px 4px 0 rgba(202, 202, 202, 0.5);
        margin: 20px;
        padding: 20px 20px 0 20px;
        background: #fff;
        .title-wrap {
            font-size: 0;
            padding-bottom: 20px;
            height: 16px;
            line-height: 16px;
            .icon-tongyongbiaotiicon {
                color: $color-primary;
                font-size: 16px;
                vertical-align: middle;
            }
            .title-text {
                font-size: 14px;
                color: #333333;
                margin-left: 10px;
                display: inline-block;
                height: 16px;
                line-height: 16px;
                vertical-align: middle;
            }
        }

        .banner-form {
            .el-form-item__label {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #666666;
                letter-spacing: 0;
                padding-right: 20px;
            }
            .el-form-item__content {
                .from-input {
                    width: 320px;
                    .el-input__inner {
                        border-radius: 3px;
                        border: 1px solid #dcdcdc;
                        height: 32px;
                        padding: 0 10px;
                    }
                }
                .cover-content {
                    position: relative;
                    .cover-picture {
                        width: 339px;
                        height: 130px;
                    }
                    .icon-jinggaochacha {
                        cursor: pointer;
                        font-size: 16px;
                        color: #ec6a69;
                        position: absolute;
                        top: -15px;
                        left: 330px;
                    }
                }

                .picture-uploader {
                    width: 327px;
                    height: 130px;
                    background: #d8d8d8;
                    text-align: center;
                    .picture-content {
                        margin-top: 40px;
                        .icon-camera {
                            font-size: 24px;
                            color: #fff;
                        }
                        .picture_text {
                            margin-top: 2px;
                            font-family: PingFang-SC-Medium;
                            font-size: 14px;
                            color: #ffffff;
                            letter-spacing: 0;
                            line-height: 14px;
                        }
                    }
                }
                .uploader-tips {
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #999999;
                    letter-spacing: 0;
                    line-height: 16px;
                    font-weight: normal;
                    margin-top: 10px;
                }
                .form-datetime {
                    width: 320px;
                    .el-input__inner {
                        height: 32px;
                    }
                    .el-input__prefix {
                        .el-input__icon {
                            line-height: 32px;
                        }
                    }
                    .el-input__suffix {
                        .el-input__icon {
                            line-height: 32px;
                        }
                    }
                }
                .submit-btn {
                    width: 100px;
                    height: 32px;
                    border-radius: 3px;
                    padding: 0;
                }
                .cancle-btn {
                    width: 100px;
                    height: 32px;
                    border-radius: 3px;
                    padding: 0;
                    background: #f5f5f5;
                    border: 1px solid #cccccc;
                    color: #666;
                    margin-left: 16px;
                }
            }
        }
    }
}
</style>
